


























import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { OnboardingBalanceTransfer, OnboardingScheduleContribution } from "@/employee/route-names";
import { useThemeStore } from "@/shared/store/theme";
import UpfrontContributionBase from "@/employee/components/onboarding/upfront-contribution/UpfrontContributionBase.vue";

@Component({
  components: {
    UpfrontContributionBase,
    Button
  }
})
export default class OnboardingContribution extends Vue {
  themeStore = useThemeStore();

  onSkip () {
    this.$router.push({
      name: OnboardingBalanceTransfer
    });
  }

  onContinue () {
    this.$router.push({
      name: OnboardingScheduleContribution
    });
  }
}
